import { Divider, Form, Input, Select, Space, Table, Typography, Button } from 'antd';
import {
  Card
} from 'reactstrap'
import { SearchOutlined } from '@ant-design/icons';
import { Group, OrderModel, Report } from './models/Order'
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { AccountModel } from 'app/modules/accounts/models/Account'
import DatePicker from 'react-datepicker'
import { RootState } from 'setup'
import { actions } from './redux/OrdersRedux'
import { actions as c } from 'app/modules/accounts/redux/AccountRedux'
import moment from 'moment'
import { useIntl } from 'react-intl'
import { format } from 'utils/convert'
import { listHistorySubsribe, listHistoryByChannelID } from './redux/OrdersCRUD';
import Chart from 'react-apexcharts'
import CountUp from 'react-countup'
import { ROLE_GENERAL } from 'utils/constants';

type Props = {
  className: string
  state: string
  apiAlias: string
}

const HistoryList: React.FC<Props> = ({ apiAlias, className, state }) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const [groupName, setGroupName] = useState('')
  const role: string =
    (useSelector<RootState>(({ auth }) => auth.user?.role, shallowEqual) as string) || ''
  const groups: Group[] =
    (useSelector<RootState>(({ orders }) => orders.groups, shallowEqual) as Group[]) || []
  const [currentGroup, setCurrentGroup] = useState<Group>()
  const [currentUserID, setCurrentUserID] = useState(-1)
  const [currentChannelID, setCurrentChannelID] = useState('')
  const [loading, setLoading] = useState(false)
  const [orders, setOrders] = useState<OrderModel[]>([])
  const [reports, setReports] = useState<Report[]>([])


  const accounts: AccountModel[] =
    (useSelector<RootState>(({ accounts }) => accounts.accounts, shallowEqual) as AccountModel[]) ||
    []
  let defaultDate = new Date()
  defaultDate.setDate(defaultDate.getDate() + -7)
  const [from, setFrom] = useState<Date>(defaultDate)
  const [to, setTo] = useState<Date>(new Date())
  console.log('loading', loading)

  const reloadDataTask = async () => {
    setLoading(true)
    let res
    if (currentChannelID !== '') {
      res = await listHistoryByChannelID(currentChannelID);
    } else {
      res = await listHistorySubsribe(moment(from).format('DD-MM-YYYY'), moment(to).format('DD-MM-YYYY'), currentUserID)
    }
    console.log(res)
    if (res?.data?.channels) {
      setOrders(res?.data?.channels)
    }
    if (res?.data?.report) {
      setReports(res?.data?.report)
    }
    setLoading(false)
  }

  useEffect(() => {
    reloadDataTask()
    dispatch(c.requestAccounts(1));

    return () => {};
  }, [])


  const addGroup = () => {
    if (groupName.length === 0) {
      alert('vui lòng điền tên nhóm')
      return
    }
    dispatch(actions.addGroupRequest(groupName))
    setGroupName('')
  }
  const searchByChannelID = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentChannelID(e.target.value)
  }
  const totalSubscription = useMemo(
    () => reports.reduce((total, report) => total + report.total, 0),
    [reports]
  )
  const option = {
    chart: {
      height: 350,
      type: 'line',
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      curve: 'smooth',
      lineCap: 'butt',
      colors: '#447f72',
      width: 2,
      dashArray: 0,
    },
    title: {
      text: 'subscription',
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: reports.map((rp) => rp.date),
    },
    markers: {
      size: 6,
      colors: '#447f72',
      strokeColors: '#fff',
      strokeWidth: 2,
      strokeOpacity: 0.9,
      strokeDashArray: 0,
      fillOpacity: 1,
      discrete: [],
      shape: 'circle',
      radius: 2,
      offsetX: 0,
      offsetY: 0,
      onClick: undefined,
      onDblClick: undefined,
      showNullDataPoints: true,
      hover: {
        size: undefined,
        sizeOffset: 3,
      },
    },
  }
  const chartDashboardMonitoring3AData = [
    {
      name:'subscription',
      data: reports.map((rp) => rp.total),
    },
  ]

  return (
    <div className='c-order'>
      <Card className='card-box mb-5 text-center'>
        <div className='card-box__inner'>
          <div className='card-header-alt'>
            <p className='font-weight-bold mb-0 text-black'>
              {'Số subscribe: ' +
                moment(from).format(intl.formatMessage({ id: 'DATE.MOMENT.FORMAT' })) +
                ' | ' +
                moment(to).format(intl.formatMessage({ id: 'DATE.MOMENT.FORMAT' }))
                }
            </p>
          </div>
          <h3 className='pt-1 pb-2 display-3 mt-1 font-weight-bold'>
            <span className='pr-1'>
              <CountUp
                start={0}
                end={totalSubscription}
                duration={4}
                separator=''
                delay={3}
                decimals={0}
                decimal=','
                prefix=''
                suffix=''
                formattingFn={(number) => format(number, 0, 3)}
              />
            </span>
          </h3>
        </div>
        <div className='card-box__bottom'>
          <Chart options={option} series={chartDashboardMonitoring3AData} type='line' height={205} />
        </div>
      </Card>
      <div className={`card ${className}`}>
        {/* begin::Header */}

        <div className='card-header border-0 pt-5'>
          <div className='card-toolbar justify-content-between'></div>

          <div className='card-toolbar justify-content-between'>
            <div className='card-toolbar w-100'>
              <Form layout='vertical' className='w-100'>
                <div className='row'>
                  <div className='col'>
                    <div className='row'>
                      <div className='col'>
                        <div className='row'>
                          <div className='col-12'>
                            <Form.Item
                              label={`Tìm theo ID ${apiAlias === 'like' ? 'Video' : 'Kênh'}/User`}
                              className='mb-0'
                            >
                              <Input
                                placeholder={`Tìm theo ID ${apiAlias === 'like' ? 'Video' : 'Kênh'
                                  }/User`}
                                onChange={searchByChannelID}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      {(role === ROLE_GENERAL.ADMIN || role === ROLE_GENERAL.SUPER_ADMIN) ? (
                        <div className='col'>
                          <Form.Item label='Lọc theo user' className='mb-0'>
                            <Select
                              onChange={(value) => setCurrentUserID(value)}
                              defaultValue={-1}
                              dropdownMatchSelectWidth={false}
                              defaultActiveFirstOption
                            >
                              <Select.Option value={-1}>Tất cả user</Select.Option>
                              {accounts.map((item: AccountModel) => (
                                <Select.Option key={item.id} value={item.id}>
                                  {item.username}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      ) : null}
                      <div className='col'>
                        <Form.Item label='Lọc theo nhóm' className='mb-0'>
                          <Select
                            onChange={(value) => {
                              if (value === -1) {
                                setCurrentGroup(undefined)
                              } else {
                                const group = groups.find((g) => g.id === value)
                                setCurrentGroup(group)
                              }
                            }}
                            defaultValue={-1}
                            dropdownMatchSelectWidth={false}
                            defaultActiveFirstOption
                            optionLabelProp='label'
                            dropdownRender={(menu) => (
                              <>
                                {menu}
                                <Divider style={{ margin: '8px 0' }} />
                              </>
                            )}
                          >
                            <Select.Option value={-1} label='Tất cả các nhóm'>
                              Tất cả các nhóm
                            </Select.Option>
                            {groups.map((item: Group) => (
                              <Select.Option key={item.id} value={item.id} label={item.name}>
                                <div className='d-flex justify-content-between'>
                                  <span>{item.name}</span>
                                  <Typography.Link
                                    onClick={(e) => {
                                      e.preventDefault()
                                      if (
                                        window.confirm('bạn có chắc chắn muốn xóa nhóm này') ===
                                        true
                                      ) {
                                        dispatch(actions.deleteGroupRequest(item.id))
                                      }
                                    }}
                                    style={{ whiteSpace: 'nowrap' }}
                                    className='text-danger'
                                  >
                                    Xoá
                                  </Typography.Link>
                                </div>
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                      <div className='col'>
                        <Form.Item label='Từ ngày' className='mb-0'>
                          <DatePicker
                            dateFormat={intl.formatMessage({ id: 'DATE.FORMAT' })}
                            className='form-control'
                            selected={from}
                            onChange={(date) => setFrom(date != null ? date : defaultDate)}
                            selectsStart
                            startDate={from}
                            endDate={to}
                          />
                        </Form.Item>
                      </div>
                      <div className='col'>
                        <Form.Item label='Từ ngày' className='mb-0'>
                          <DatePicker
                            dateFormat={intl.formatMessage({ id: 'DATE.FORMAT' })}
                            className='form-control'
                            selected={to}
                            onChange={(date) => setTo(date != null ? date : new Date())}
                            selectsEnd
                            startDate={from}
                            endDate={to}
                            minDate={from}
                          />
                        </Form.Item>
                      </div>
                      <div className='col'>
                        <Form.Item label='---' className='mb-0'>
                          <Button type="primary"
                            icon={<SearchOutlined rev={undefined} />}
                            loading={loading}
                            onClick={reloadDataTask}>
                            Reload dữ liệu
                          </Button>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
        {/* end::Header */}
        {/* begin::Body */}
        <div className='card-body py-3'>
          {/* begin::Table container */}
          <div className='table-responsive '>
            <Table
              loading={loading}
              bordered
              columns={[
                {
                  title: '',
                  key: 'stt',
                  dataIndex: 'stt',
                  width: 50,
                  render: (value: any, record: OrderModel, index: any) => index + 1,
                },
                {
                  title: 'ID Chanel/User',
                  key: 'channel_id',
                  dataIndex: 'channel_id',
                  width: 150,
                  render: (value: any, item: OrderModel, index: any) => {
                    return (
                      <>
                        <a
                          href={'https://www.youtube.com/channel/' + item.channel_id}
                          className='text-dark fw-bolder text-hover-primary text-sm'
                        >
                          {item.channel_id}
                        </a>
                      </>
                    )
                  },
                },
              ]}
              dataSource={orders}
              pagination={false}
            />
          </div>
          {/* end::Table container */}
        </div>
        {/* begin::Body */}
      </div>
    </div>
  )
}

export { HistoryList }
